/**
 * Formats a price/number with German locale (comma as decimal separator).
 * Used for PDF generation.
 *
 * @param value - The number or string to format
 * @param options - Optional formatting options
 * @returns Formatted string with comma as decimal separator
 */
export function formatPrice(
  value: number | string | null | undefined,
  options?: {
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  },
): string {
  if (value == null || value === "") return "";

  // Convert string to number if needed
  const numValue = typeof value === "string" ? Number.parseFloat(value) : value;

  if (Number.isNaN(numValue)) return "";

  const { minimumFractionDigits = 2, maximumFractionDigits = 2 } =
    options ?? {};

  return numValue.toLocaleString("de-DE", {
    minimumFractionDigits,
    maximumFractionDigits,
  });
}

/**
 * Formats a price/number with German locale for display in PDF.
 * Always shows 2 decimal places.
 */
export function formatPriceDisplay(
  value: number | string | null | undefined,
): string {
  return formatPrice(value, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
